import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Tooltip } from '@mui/material';

import agregarCategoria from '../img/tabla/agregarCategoria.svg';
import agregar from '../img/tabla/agregar.svg';
import quitar from '../img/tabla/quitar.svg';
import duplicar from '../img/tabla/duplicar.svg';

import { iniAddItem, iniAddTitleWithItems, iniDuplicateItem, iniRemoveItem } from '../../../redux/actions/pptos';

export const ItemsActions = ({
    item,
    openSubTitles,
    hanldeChangeOpenSubtitle = false,
    showAddTitle_ = true,
    showAddItem_ = true,
    showRemoveItem_ = true,
    showDuplicateItem_ = true,
    sorting = 0
}) => {

    const dispatch = useDispatch();
    const { detail } = useSelector(state => state.ppto);
    const { items } = useSelector(state => state.ppto.detail);

    const addTitle = () => {
        console.log('--from items actions--')
        // dispatch(iniAddTitle(items));
        dispatch(iniAddTitleWithItems(items));
    }

    const addItem = () => {
        const idTitle = (item.tipo === 'title' ? item.id : item.id_titulo)
        const categoryId = item.id_categoria

        dispatch(iniAddItem(idTitle, items, sorting, null, categoryId))
        if (!openSubTitles && hanldeChangeOpenSubtitle) {
            hanldeChangeOpenSubtitle()
        }
    }

    const duplicateItem = () => {
        dispatch(iniDuplicateItem(items, item, detail));
    }

    const removeItem = () => {
        dispatch(iniRemoveItem(items, item, detail));
    }

    return (
        <>
            {showAddTitle_ && (
                <Tooltip title="Agregar título">
                    <button className='ButtonsAction'>
                        <img
                            className='tabla-icons-actions'
                            src={agregarCategoria}
                            alt='agregar título'
                            onClick={addTitle}
                        />
                    </button>
                </Tooltip>
            )}
            {showAddItem_ && (
                <Tooltip title="Agregar servicio">
                    <button className='ButtonsAction'>
                        <img
                            className='tabla-icons-actions'
                            src={agregar}
                            alt='agregar servicio'
                            onClick={addItem}
                        />
                    </button>
                </Tooltip>
            )}
            {(showRemoveItem_ && parseFloat(item?.total_gasto_real || 0) === 0) && (
                <Tooltip title={item.tipo === 'title' ? 'Quitar título' : 'Quitar servicio'}>
                    <button className='ButtonsAction'>
                        <img
                            className='tabla-icons-actions'
                            src={quitar}
                            alt='quitar título'
                            onClick={removeItem}
                        />
                    </button>
                </Tooltip >
            )}
            {
                showDuplicateItem_ && (
                    <Tooltip title={item.tipo === 'title' ? 'Duplicar título' : 'Duplicar servicio'}>
                        <button className='ButtonsAction'>
                            <img
                                className='tabla-icons-actions'
                                src={duplicar}
                                alt='duplicar título'
                                onClick={duplicateItem}
                            />
                        </button>
                    </Tooltip>
                )
            }
        </>
    );
};